import React, { FC } from 'react';
import { BpDesignSystem } from '../../types';
import { Button, ButtonProps } from './Button';
import { Tooltip, TooltipProps } from '../Tooltip/Tooltip';

export type ButtonWithTooltipProps = BpDesignSystem.PropsWithChildren<
  ButtonProps & {
    slotProps?: {
      tooltip?: Omit<TooltipProps, 'children'>;
    };
  }
>;

export const ButtonWithTooltip: FC<ButtonWithTooltipProps> = ({ slotProps, ...buttonProps }) => {
  return (
    <Tooltip {...slotProps?.tooltip}>
      <Button {...buttonProps} />
    </Tooltip>
  );
};
